import { GET_LIST_ITEMS_START } from '../../types';

export const get_list_items = (payload) => ({
  type: GET_LIST_ITEMS_START,
  payload,
});
